{
  "cancel": {},
  "communicationError": {
    "cancel": {},
    "tryAgain": {}
  },
  "report": {},
  "run": {},
  "success": {
    "close": {}
  },
  "unsuccess": {
    "back": {},
    "cancel": {},
    "proceedAnyway": {}
  }
}
